import { useCallback } from 'react';
import uuid from 'uuid/v1';
import { COMPARISON_OPERATOR, LOGICAL_OPERATOR } from 'modules/push-api/utils/subscriptionConsts';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

const createNewField = () => ({
    id: uuid(),
    name: null,
    logicalOperator: LOGICAL_OPERATOR.OR,
    filters: [
        {
            id: uuid(),
            newValueCriterion: null,
            newComparisonOperatorCriterion: COMPARISON_OPERATOR.ALWAYS_FALSE,
            logicalOperator: LOGICAL_OPERATOR.AND,
            previousValueCriterion: null,
            previousComparisonOperatorCriterion: COMPARISON_OPERATOR.ALWAYS_FALSE,
        },
    ],
});

export const useFields = () => {
    const { value: fields, onChange: setFields } = useFormFieldValue({ field: 'fields' });

    const addField = () => {
        setFields([...fields, createNewField()]);
    };

    const deleteField = useCallback(
        index => {
            setFields(fields.filter((_, i) => i !== index));
        },
        [fields, setFields]
    );

    return { fields, setFields, addField, deleteField };
};
